<template>
  <v-stepper
    v-model="form.step"
    elevation="0"
  >    
    <v-stepper-header
      elevation="0"
      style="box-shadow: none;"
    >
      <v-stepper-step
        :complete="form.step > 1"
        step="1"
        color="success"
      >
        Veículo 
        <span v-if="order">({{ order.plate }})</span>      
        <small>Placa do veículo</small>      
      </v-stepper-step>

      <v-stepper-step
        :complete="form.step > 2"
        step="2"
        color="success"
      >
        Documentos
        <small>Envio de documentos</small>
      </v-stepper-step>

      <v-stepper-step
        :complete="form.step > 3"
        step="3"
        color="success"
      >
        Pagamento <span v-if="order">R$ {{ order.type_solicitation.value }}</span>
        <small>Forma de pagamento</small>
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <OrderSimpleVehicleForm
          :order-kind="orderKind"
          @orderCreate="onEventOrderCreated"
        />      
      </v-stepper-content>

      <v-stepper-content step="2">
        <OrderDocumentList
          v-if="order"
          :order="order" 
          @documentsCreated="onEventDocumentsCreated"
        />
      </v-stepper-content>

      <v-stepper-content step="3">
        <OrderPaymentForm
          v-if="order && !payment"
          :order="order" 
          @doPayment="onEventPaymentProcessed"
        />

        <OrderPaymentInfoSuccess
          v-if="payment"
          :payment="payment"
        />     
      </v-stepper-content>
    </v-stepper-items>   
  </v-stepper>
</template>

<script>
  import OrderSimpleVehicleForm from './OrderSimpleVehicleForm.vue';
  import OrderDocumentList from './OrderDocumentList.vue';
  import OrderPaymentForm from './OrderPaymentForm.vue';
  import OrderService from '@/services/pedidos.service';
  import OrderPaymentInfoSuccess from './OrderPaymentInfoSuccess.vue';

  export default {
    name: 'OrderCheckout',
    components: {
      OrderSimpleVehicleForm,
      OrderDocumentList,
      OrderPaymentForm,
      OrderPaymentInfoSuccess
    },
    props: {
      orderKind: {
        type: String,
        required: true
      }
    },
    data: () => ({
      form: {
        step: 1,      
      },
      order: null,
      payment: null
    }),
    watch: {
      '$route.params.id'(newId, oldId) {      
        this.fetchOrder()
      }
    },
    
    mounted() {    
      this.fetchOrder()    
    },

    methods: {
      onEventOrderCreated({order}) {
        this.order = order;
        this.form.step = 2;
        this.goToOrder(order.id);
      },

      onEventDocumentsCreated() {      
        this.form.step = 3;
        this.fetchOrder();
      },

      onEventPaymentProcessed(event) {        
        this.fetchOrder();
        this.fetchPayment();
      },

      fetchOrder() {
        if (!this.$route.params.id) return;

        OrderService
          .show(this.$route.params.id)
          .subscribe({
            next: (response) => {            
              this.order = response;  
              this.checkStep()          
            }
          });
      },

      fetchPayment() {
        if (!this.order || !this.order.id) return;
        this.payment = { id: 'pay_123456', status: 'completed', value: this.order.type_solicitation.value }; // Mocked payment data
      // OrderService
      //   .payment(this.order.id)
      //   .subscribe({
      //     next: (response) => {            
      //       this.payment = response[0];                        
      //     }
      // });
      },

      goToOrder(id) {
        this.$router.push({ 
          name: 'orders-vehicle-renewal-detail', 
          params: { id: id } 
        });
      },

      checkStep() {      
        if (this.order) {
          if (this.order.status.code === 'pending_payment') {
            this.form.step = 3;
          } else if (this.order.status.code === 'waiting_documents') {
            this.form.step = 2;
          } else {
            this.form.step = 1;
          }
        } else {
          this.form.step = 1;
        }
      }
    },
  };
</script>